export const RateTag = {
  Recommended: 'Recommended',
  Cheapest: 'Cheapest',
  Fastest: 'Fastest',
  BestValue: 'BestValue',
  TwoDay: '2Day',
};
